import { Box, Text } from '@openfin/ui-library';
import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { StoredNotification } from '../../../model/StoredNotification';
import { RemoveNotifications } from '../../../store/Actions';
import { RootState } from '../../../store/State';
import { NotificationList } from '../../components/NotificationList/NotificationList';
import { EmptyNotificationListCard } from '../../components/Cards/Cards';

interface FrameBodyProps {
  isStream: boolean;
  id: string;
  notifications?: StoredNotification[];
  removeNotifications?: (...notifications: StoredNotification[]) => void;
}

type Props = FrameBodyProps & ReturnType<typeof mapState>;

export const FrameBodyComponent: React.FC<Props> = (props) => {
  const { removeNotifications, notifications } = props;

  return (
    <Container flexDirection="column">
      {notifications.length === 0 && (
        <Content>
          <EmptyCardContainer>
            <EmptyNotificationListCard />
          </EmptyCardContainer>
        </Content>
      )}
      {notifications.length > 0 && (
        <Content>
          <ClearButton onClick={() => removeNotifications?.(...notifications)}>Clear</ClearButton>
          <NotificationList notifications={notifications} />
        </Content>
      )}
    </Container>
  );
};

const Content = styled(Box)`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const Container = styled(Box)`
  padding-top: ${(props) => props.theme.px.base};
  flex: 1;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

const EmptyCardContainer = styled(Box)`
  margin: 0 auto;
`;

const ClearButton = styled(Text)`
  margin-left: auto;
  margin-right: ${(props) => props.theme.px.large};
  margin-bottom: ${(props) => props.theme.px.base};
  cursor: pointer;
  user-select: none;
`;

const mapState = (state: RootState, ownProps: FrameBodyProps) => ({
  notifications: Object.values(
    (ownProps.isStream
      ? state.sortedNotifications.byStream[ownProps.id]
      : state.sortedNotifications.byApplication[ownProps.id]) ?? []
  ),
});

const mapDispatch = (dispatch: Dispatch) => ({
  removeNotifications: (...notifications: StoredNotification[]) =>
    dispatch(new RemoveNotifications(notifications)),
});

export const FrameBody = connect(mapState, mapDispatch)(FrameBodyComponent);
